import Props from "./Properties"
import {LocationProperties} from './PropertyTemplates.js'

class Location
{
    readonly id: string;
    name: string;
    properties: any[] = [];

    constructor(data: any) {
        if (!data) {
            throw "Null data for Location";
        }
        this.id = data.id;
        this.name = data.name ? data.name : this.id;
        this.properties = Props.parse(LocationProperties, data);
    }

}

export default Location;
